import React from "react";
import { Link } from "react-router-dom";
import "./PageNotFound.css";
import Navbar from "./Navbar";
import Fotter from "./Fotter"; // ✅ make sure this file really is Fotter.js
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const PageNotFound = () => {
  return (
    <>
      <Navbar />
      <div className="notfound-container">
        <h1 className="error-code">404</h1>
        <p className="error-message">
          Oops, the page you're looking for isn't here.
        </p>
        <Link to="/" className="back-button" aria-label="Go back to auctions">
          <FontAwesomeIcon icon={faArrowLeft} /> Back to Auctions
        </Link>
      </div>
      <Fotter />
    </>
  );
};

export default PageNotFound;
